import axios from 'axios';
import { useStore } from '@nanostores/react';
import { currentUrl } from '@stores/urlStore';
import { getVariantInventory } from '../api/admin';
import { getProductInventory } from '../api/shopify';

export const slugString = (slug) => {
	// prevent removing dashes from `one-piece`

	if (!slug) return null;
	let op;
	if (slug.match(/one-piece/)) {
		op = slug.match(/one-piece/);
	} else if (slug.match(/two-piece/)) {
		op = slug.match(/two-piece/);
	} else if (slug.match(/fleece-lined/)) {
		op = slug.match(/fleece-lined/);
	} else if (slug.match(/2-pack/)) {
		op = slug.match(/2-pack/);
	} else if (slug.match(/3-pack/)) {
		op = slug.match(/3-pack/);
	} else if (slug.match(/3-Pack/)) {
		op = slug.match(/3-Pack/);
	} else if (slug.match(/4-pack/)) {
		op = slug.match(/4-pack/);
	} else if (slug.match(/5-pack/)) {
		op = slug.match(/5-pack/);
	} else if (slug.match(/8-pack/)) {
		op = slug.match(/8-pack/);
	} else if (slug.match(/12-pack/)) {
		op = slug.match(/12-pack/);
	} else if (slug.match(/4-piece/)) {
		op = slug.match(/4-piece/);
	} else if (slug.match(/6-piece/)) {
		op = slug.match(/6-piece/);
	} else if (slug.match(/7-pack/)) {
		op = slug.match(/7-pack/);
	} else if (slug.match(/v-neck/)) {
		op = slug.match(/v-neck/);
	} else if (slug.match(/zip-up/)) {
		op = slug.match(/zip-up/);
	} else if (slug.match(/all-in-one/)) {
		op = slug.match(/all-in-one/);
	} else if (slug.match(/arms-out/)) {
		op = slug.match(/arms-out/);
	} else if (slug.match(/4-sided/)) {
		op = slug.match(/4-sided/);
	} else if (slug.match(/one-shoulder/)) {
		op = slug.match(/one-shoulder/);
	}

	let slugString;

	if (op && op.length > 0) {
		let withoutOp;
		if (
			op.toString() === '2-pack' ||
			op.toString() === '3-pack' ||
			op.toString() === '3-Pack' ||
			op.toString() === '4-pack' ||
			op.toString() === '5-pack' ||
			op.toString() === '12-pack' ||
			op.toString() === '8-pack' ||
			op.toString() === '4-piece' ||
			op.toString() === '6-piece' ||
			op.toString() === '7-pack' ||
			op.toString() === 'zip-up' ||
			op.toString() === 'arms-out' ||
			op.toString() === 'v-neck' ||
			op.toString() === 'all-in-one' ||
			op.toString() === 'one-shoulder' ||
			op.toString() === '4-sided' ||
			op.toString() === 'one-piece' ||
			op.toString() === 'two-piece' ||
			op.toString() === 'fleece-lined'
		) {
			if (
				slug === 'on-the-go-one-piece' ||
				slug === 'tie-swimsuit-one-piece' ||
				slug === 'long-rashguard-one-piece' ||
				slug === 'kimono-tie-one-piece' ||
				'zipper-one-piece'
			) {
				// withoutOp = slug.split('one-piece')[0]
				// slugString = withoutOp.replace(/-/g, '%20')
				slugString = slug.replace(/-/g, '%20');
			} else if (slug === 'long-sleeve-one-piece-swimsuit') {
				slugString = 'long%20sleeve%20one-piece%20swimsuit';
			} else if (
				slug === 'the-amalfi-one-piece-eco-nylon-cherry-red-classic'
			) {
				slugString =
					'the%20amalfi%20one%20piece%20eco%20nylon%20cherry%20red%20classic';
			} else if (
				slug === 'the-amalfi-one-piece-eco-nylon-white-classic'
			) {
				slugString =
					'the%20amalfi%20one%20piece%20eco%20nylon%20white%20classic';
			} else if (slug === 'cotton-fleece-one-piece') {
				slugString = 'cotton%20fleece%20one-piece';
			} else if (
				slug === 'yoyo3-bundle-6-0-car-seat-adapters-black-with-black'
			) {
				slugString =
					'yoyo3%20bundle%206-0%20car%20seat%20adapters%20black%20with%20black';
			} else if (slug === 'fleece-zipper-f-one-piece') {
				slugString = 'fleece%20zipper%20f%20one-piece';
			} else if (slug === 'one-piece-baby-pajamas') {
				slugString = 'one-piece%20baby%20pajamas';
			} else if (slug === 'cotton-rib-zipper-one-piece') {
				slugString = 'cotton%20rib%20zipper%20one-piece';
			} else {
				withoutOp = slug.split(op)[1];
				slugString = op + withoutOp.replace(/-/g, '%20');
			}
		} else {
			op = op[0];
			withoutOp = slug.split(op)[0];
			slugString = withoutOp.replace(/-/g, '%20') + op;
		}
	} else {
		slugString = slug.replace(/-/g, '%20');
	}

	return slugString;
};

export function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

export const extractText = (node) => {
	const text = [...node.childNodes].find(
		(child) => child.nodeType === Node.TEXT_NODE
	);
	return text && text.textContent.trim();
};

export const trimLeadingTrailingSpaces = (str) => {
	return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
};

export const trimLeadingSpaces = (str) => {
	return str.replace(/^\s\s*/, '');
};

export const decodeHTMLEntities = (str) => {
	if (!str) return '';

	const doc = new DOMParser().parseFromString(str, 'text/html');
	// console.log('str', str, doc.documentElement.textContent);
	return doc.documentElement.textContent;
};

export function checkVisible(elm) {
	if (elm && elm !== 'undefined') {
		var rect = elm.getBoundingClientRect();
		var viewHeight = Math.max(
			document.documentElement.clientHeight,
			window.innerHeight
		);
		return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
	} else {
		return false;
	}
}

export function isFullyVisible(elem, tolerance = 0.5) {
	const rect = elem.getBoundingClientRect();
	const windowHeight =
		window.innerHeight || document.documentElement.clientHeight;
	const windowWidth =
		window.innerWidth || document.documentElement.clientWidth;

	// Check with tolerance for being within the viewport
	const inViewVertically =
		rect.top <= windowHeight + tolerance && rect.bottom >= -tolerance;
	const inViewHorizontally =
		rect.left <= windowWidth + tolerance && rect.right >= -tolerance;
	const inViewport = inViewVertically && inViewHorizontally;

	// Check for CSS visibility, 'hidden' attribute, and dimensions
	const style = getComputedStyle(elem);
	const notHiddenByCSS =
		style.display !== 'none' &&
		style.visibility !== 'hidden' &&
		parseFloat(style.opacity) > 0;
	const notHiddenAttribute = !elem.hidden;
	const hasDimensions =
		elem.offsetWidth > 0 ||
		elem.offsetHeight > 0 ||
		elem.getClientRects().length > 0;

	return inViewport && notHiddenByCSS && notHiddenAttribute && hasDimensions;
}

export function getViewportSize(w) {
	// Use the specified window or the current window if no argument
	w = w || window;

	// This works for all browsers except IE8 and before
	if (w.innerWidth != null) return { w: w.innerWidth, h: w.innerHeight };

	// For IE (or any browser) in Standards mode
	var d = w.document;
	if (document.compatMode == 'CSS1Compat')
		return {
			w: d.documentElement.clientWidth,
			h: d.documentElement.clientHeight,
		};

	// For browsers in Quirks mode
	return { w: d.body.clientWidth, h: d.body.clientHeight };
}

export function splitMulti(str, separators) {
	var tempChar = 't3mp'; //prevent short text separator in split down

	//split by regex e.g. \b(or|and)\b
	var re = new RegExp('\\b(' + separators.join('|') + ')\\b', 'g');
	str = str.replace(re, tempChar).split(tempChar);

	// trim & remove empty
	return str.map((el) => el.trim()).filter((el) => el.length > 0);
}

export const isFutureDate = (value) => {
	let d_now = new Date();
	let d_inp = new Date(value);
	return d_now.getTime() <= d_inp.getTime();
};

export const getFirstProducts = async (queryUrl) => {
	// console.time('query')
	const result = await fetch(queryUrl).then((res) => res.json());

	if (result && result.products) {
		result.products = await Promise.all(
			result.products.map(async (p) => {
				if (
					p.tags.includes('bundle-builder-product') &&
					!p.title.includes('[hidden]')
				) {
					p.variants = mapVariantsToMetafields(p, p.variants);
					p.variants = await findEffVariantsWithInventory(p.variants);
				}
				return p;
			})
		);
	}
	result.products = removeOutOfStockProducts(result.products);

	return result;
};

export const getNextProducts = async (queryUrl) => {
	let result;
	let products = [];

	result = await fetch(queryUrl).then((res) => res.json());

	if (result && result.products) {
		result.products = await Promise.all(
			result.products.map(async (p) => {
				if (
					p.tags.includes('bundle-builder-product') &&
					!p.title.includes('[hidden]')
				) {
					p.variants = mapVariantsToMetafields(p, p.variants);
					p.variants = await findEffVariantsWithInventory(p.variants);
				}
				return p;
			})
		);
		result.products = removeOutOfStockProducts(result.products);
		return {
			products: result.products.flat(1),
			data: result,
		};
	}
};

export const getProducts = async (pages, queryUrl) => {
	//
	let result;
	let products = [];
	let morePagesAvailable = true;
	let currentPage = 0;

	if (!pages || !queryUrl) {
		return null;
	}

	for (let i = 0; i < pages; i++) {
		// console.time('page loop')
		//
		currentPage++;
		result = await axios(`${queryUrl}&page=${currentPage}`);

		products.push(result.data.products);

		morePagesAvailable = currentPage < pages;

		// console.timeEnd('page loop')
	}

	if (products && products.length) {
		products = await Promise.all(
			products.map(async (p) => {
				if (
					p.tags.includes('bundle-builder-product') &&
					!p.title.includes('[hidden]')
				) {
					p.variants = mapVariantsToMetafields(p, p.variants);
					p.variants = await findEffVariantsWithInventory(p.variants);
				}
				return p;
			})
		);
		products = removeOutOfStockProducts(products);
		return {
			products: products.flat(1),
			data: result.data,
		};
	}
};

export const paginatedFetch = async (url, page = 1, previousResponse = []) => {
	return await fetch(`${url}&page=${page}`) // Append the page number to the base URL
		.then((response) => response.json())
		.then((newResponse) => {
			let products = newResponse.products;

			let response = [...previousResponse, ...products]; // Combine the two arrays

			if (products.length !== 0) {
				page++;

				return paginatedFetch(url, page, response);
			}

			return response;
		});
};

export const getFilteredFilters = (options) => {
	return [...options].map((option) => {
		if (option.filterType === 'opt_gender') {
			option.values = option.values.filter(
				(f) => !f.key.includes('Cash Gift')
			);
		}
		return option;
	});
};

export const multiFilter = (variants, filters) => {
	const filterKeys = Object.keys(filters);

	let filteredVariants = variants.filter((variant) => {
		return filterKeys.every((key) => {
			if (!filters[key].length) return true;
			// Loops again if product[key] is an array (for material attribute).
			if (Array.isArray(variant[key])) {
				return variant[key].every((keyEle) =>
					filters[key].includes(keyEle)
				);
			}

			// MBR-2342 fix for BOOST filters not showing correct values
			if (filters[key].includes('Blue')) {
				filters[key].push('Navy');
				filters[key].push('Navy Blue Heather');
				filters[key].push('Blue Fox');
				filters[key].push('Big Blue + Come Sail Away');
				filters[key].push('Blue Stripe');
				filters[key].push('Baby Blue Heather + Navy Blue Heather');
				filters[key].push('Heather Grey + Navy Blue Heather');
				filters[key].push('Navy Blue Heather + Big Blue');
				filters[key].push('Big Blue + Come Sail Away + Blue Cabana');
				filters[key].push('Black + Blue Flannel');
				filters[key].push(
					'Welcome Aboard + Shark Attack + Come Sail Away + Big Blue'
				);
				filters[key].push('Blue Jean');
				filters[key].push('Come Sail Away + Blue Cabana');
				filters[key].push('Navy Blue Heather + Come Sail Away');
				filters[key].push('Indigo');
				filters[key].push('Dark Rinse Wash');
				filters[key].push('Oh, Snap!');
				filters[key].push('Chicago Style + Navy + White Stripe');
				filters[key].push('Spectacular + Made With Code');
				filters[key].push('My First Bicycle + Rock My World');
				filters[key].push(
					'Heather Grey + Baby Blue Heather + Navy Blue Heather'
				);
				filters[key].push('Navy Blue Heather + Baby Blue Heather');
				filters[key].push('Navy + White');
				filters[key].push('Navy French Stripe');
				filters[key].push('Dark Rinse');
				filters[key].push('Blue Rinse');
				filters[key].push('Denim');
				filters[key].push('Thick Navy Stripe');
				filters[key].push('Navy Heather');
				filters[key].push('Navy + Heather Grey');
				filters[key].push('Grey + Navy');
				filters[key].push('Navy Blue Heather + Navy French Stripe');
				filters[key].push('Navy Blue Heather + Heather Grey');
				filters[key].push('Blue + Navy + Grey');
				filters[key].push(
					'Navy Blue Heather + Baby Blue Heather + Heather Grey'
				);
				filters[key].push('Navy + Light Blue + Mint');
				filters[key].push('Heather Grey + Navy Heather');
				filters[key].push('Navy French Stripe + Watch Over You');
				filters[key].push('Navy/Mint');
				filters[key].push('Navy Stripe');
				filters[key].push('Navy French Stripe + White Elephant');
				filters[key].push('Navy/Light Blue French Stripe');
				filters[key].push(
					'Light Blue French Stripe + Navy Cabana Stripe'
				);
				filters[key].push('Navy Base + Wedge');
				filters[key].push('Navy Base');
				filters[key].push('Navy + Grey');
				filters[key].push('Heather Navy');
				filters[key].push('French Blue');
				filters[key].push(
					'Light Blue French Stripe + Blue Cabana Stripe'
				);
				filters[key].push('Navy Heather + Heather Grey');
				filters[key].push('Navy Heather + White Elephant');
				filters[key].push('Navy Heather + Navy + White French Stripe');
				filters[key].push('Navy + White French Stripe');
				filters[key].push('Heather Blue Navy');
				filters[key].push('Navy + White + Grey Stripe');
				filters[key].push('Heather Navy + White');
				filters[key].push('Navy Washed Natural');
				filters[key].push('Navy Classic Stripe');
				filters[key].push('Navy + White Stripe');
				filters[key].push('Navy Cabana Stripe');
				filters[key].push('Navy Windowpane');
				filters[key].push('Twilight Blue');
				filters[key].push('Blue + White Multistripe');
				filters[key].push('Blue + White Stripe Ombre');
				filters[key].push('Blue Cabana Stripe');
				filters[key].push('Blues');
			}
			if (filters[key].includes('Black')) {
				filters[key].push('Charcoal');
				filters[key].push('Peace Out + Oh Donut Even');
				filters[key].push('Black + White');
				filters[key].push('White + Black + Grey');
				filters[key].push('Black + White Stripe');
				filters[key].push('Black Heather');
				filters[key].push('Black + White Flannel');
				filters[key].push('Black French Stripe');
				filters[key].push('Black Heather + Heather Grey');
				filters[key].push('Heather Black');
			}
			if (filters[key].includes('Red')) {
				filters[key].push('Bright Pink');
				filters[key].push('Luxe Red');
				filters[key].push('Red Check');
				filters[key].push('Red Stripe');
				filters[key].push('Red Heather');
				filters[key].push('Red Windowpane');
				filters[key].push('Red + White Stripe');
			}
			if (filters[key].includes('Pink')) {
				filters[key].push('Baby Pink');
				filters[key].push('Light Pink');
				filters[key].push('Pink Poodle + Wild Child + Unicorn Dreams');
				filters[key].push('Baby Pink Heather');
				filters[key].push('Black + Hot Pink');
				filters[key].push('Hot Pink + Dark Purple');
				filters[key].push('Making Waves + Vitamin Sea');
				filters[key].push(
					'Making Waves + Little Seahorse + Vitamin Sea'
				);
				filters[key].push('Purple + White + Pink + White');
				filters[key].push('Aloha Sunshine + Vitamin Sea + Pink Cabana');
				filters[key].push('Aloha Sunshine + Strawberry Patch');
				filters[key].push('Stuck on You + Fir Ever');
				filters[key].push('Sweet Hearts + Ombré Unicorn');
				filters[key].push('Believe in Unicorns + Bonjour Croissant');
				filters[key].push('Fuchsia');
				filters[key].push('Pink + Purple');
				filters[key].push('Pink + White Stripe');
				filters[key].push('Pink Stripe');
				filters[key].push('Pink Velour');
				filters[key].push('Pink Polka Dot');
				filters[key].push(
					'Baby Pink Heather + Purple Heather + Heather Grey'
				);
				filters[key].push('Pink French Stripe');
				filters[key].push('Pink Heather');
				filters[key].push('Pink Seersucker');
				filters[key].push('Pink Check');
				filters[key].push('Hot Pink');
				filters[key].push('Pink + White Classic Stripe');
				filters[key].push('Pink + White Ombre');
				filters[key].push('Pink Cabana Stripe');
				filters[key].push('Pink Windowpane');
				filters[key].push('Baby Pink Classic Stripe');
				filters[key].push('Pinks');
			}
			if (filters[key].includes('Purple')) {
				filters[key].push('Purple Heather');
				filters[key].push('Black + Dark Purple');
				filters[key].push('Heather Grey + Dark Purple Heather');
				filters[key].push('Little Seahorse + Purple Cabana');
				filters[key].push('Little Magic + Purple Cabana');
				filters[key].push('Purple Stripe');
				filters[key].push('Dark Purple');
				filters[key].push('Purple + White');
				filters[key].push(
					'Purple Cabana Stripe + Aloha Sunshine + Le Macaron + Pink Cabana Stripe'
				);
				filters[key].push('Purple Heart');
				filters[key].push('Purple Polka Dot');
				filters[key].push('Dark Purple Heather');
				filters[key].push(
					'Over the Rainbow + Purple Stripe + Little Magic'
				);
				filters[key].push('Grape');
				filters[key].push(
					'Making Waves + Vitamin Sea + Little Seahorse'
				);
				filters[key].push('Believe in Unicorns + Hello Narwhal');
				filters[key].push('Like A Diamond + Purple');
				filters[key].push('Lavender');
				filters[key].push('Lilac');
				filters[key].push('Lilac + White French Stripe');
			}
			if (filters[key].includes('Grey')) {
				filters[key].push('Polly Wants a Cracker + Grey Cabana');
				filters[key].push('Under the Palms + Grey Cabana');
				filters[key].push('Under the Palms + Heather Grey');
				filters[key].push('Grey + Heather Grey');
				filters[key].push('Grey + White');
				filters[key].push('Grey Stripe');
				filters[key].push('Heather Grey');
				filters[key].push('Black + Heather Grey');
				filters[key].push(
					'Grey + Heather Grey and Black + Heather Grey'
				);
				filters[key].push('Dark Charcoal');
				filters[key].push('White Heather');
				filters[key].push('Wild Child + Fox Trot');
				filters[key].push('Grey + White Stripe');
				filters[key].push('Grey Chambray');
				filters[key].push('Dark Grey');
				filters[key].push('Heather Grey + Black Heather');
				filters[key].push('Heather Grey + White');
				filters[key].push('Heather Grey with White');
				filters[key].push('Heather Grey + Black Elephant');
				filters[key].push('Grey Cabana Stripe');
				filters[key].push('Grey + White Classic Stripe');
				filters[key].push('Grey Classic Stripe');
				filters[key].push('Grey Classic Stripe + White Elephant');
				filters[key].push('Neutral');
			}
			if (filters[key].includes('Yellow')) {
				filters[key].push('Yellow Gingham');
				filters[key].push('Yellow + White Classic Stripe');
				filters[key].push('Yellow + White French Stripe');
				filters[key].push('Yellow Heather');
				filters[key].push('Yellow Windowpane');
			}
			if (filters[key].includes('Grey Elephant')) {
				filters[key].push('Grey Elephant + Scoot Around');
				filters[key].push(
					'Grey Elephant + Pretzel Twist + Softly Served'
				);
				filters[key].push('Grey Elephant + Pretzel Twist');
				filters[key].push('Pretzel Twist + Grey Elephant');
				filters[key].push(
					'Pretzel Twist + Grey Elephant + Scoot Around'
				);
				filters[key].push('Grey Elephant + Pistachio');
				filters[key].push('Grey Elephant +Pistachio');
				filters[key].push('Grey Elephant Costume');
			}
			if (filters[key].includes('Lemonade Stand')) {
				filters[key].push('Lemonade Stand + Grey Cabana Stripe');
				filters[key].push('Lemonade Stand + Pretzel Twist');
				filters[key].push('Grill Master + Lemonade Stand');
				filters[key].push('Lemonade Stand + Sunshine');
			}
			if (filters[key].includes('Grill Master')) {
				filters[key].push('Grill Master + Blue Cabana Stripe');
				filters[key].push('Grill Master + Come Sail Away');
			}
			if (filters[key].includes('Beach Ball')) {
				filters[key].push(
					'Baby Blue Heather + Rainbow Beach Ball + Heather Grey'
				);
			}

			if (filters[key].includes('Cream')) {
				filters[key].push('Cream Heather');
				filters[key].push('Tan');
				filters[key].push('Oatmeal Heather');
				filters[key].push('Khaki');
			}

			if (filters[key].includes('Brunch Bunch')) {
				filters[key].push('Grey Cabana Stripe + Brunch Bunch');
			}

			if (filters[key].includes('Blue Lightning Strike')) {
				filters[key].push('Blue Cabana Stripe + Blue Lightning Strike');
				filters[key].push('Blue Lightning Strike + Blue Cabana Stripe');
			}
			if (filters[key].includes('Light Up The Holidays')) {
				filters[key].push('Grey Cabana Stripe + Light Up The Holidays');
			}

			if (filters[key].includes('Green')) {
				filters[key].push('Green Heather');
				filters[key].push('Green + White Stripe');
				filters[key].push('Green Classic Stripe');
				filters[key].push('Sage');
				filters[key].push('Light Sage');
				filters[key].push('Sage Green');
				filters[key].push('Green Stripe');
			}

			if (filters[key].includes('Light Blue')) {
				filters[key].push('Light Blue + White Stripe');
				filters[key].push('Chambray');
				filters[key].push('Baby Blue Heather');
				filters[key].push('Light Blue Heather');
				filters[key].push('Light Blue Seersucker');
				filters[key].push('Light Blue French Stripe');
				filters[key].push('Light Blue + White French Stripe');
				filters[key].push('Light Blue + White Classic Stripe');
				filters[key].push('Pastel Blue');
				filters[key].push('Mint');
				filters[key].push('Turquoise Elephant');
			}

			if (filters[key].includes('Prints Charming')) {
				filters[key].push('Light Blue Cabana Stripe + Prints Charming');
			}

			if (filters[key].includes('Very Cherry Blossoms')) {
				filters[key].push('Very Cherry Blossoms + Pink Cabana Stripe');
			}
			if (filters[key].includes('Great Wave')) {
				filters[key].push('Great Wave + Blue Cabana Stripe');
			}
			if (filters[key].includes('Let It Snowman')) {
				filters[key].push(
					'Green Fir Ever + Let It Snowman + Blue Snowflakes'
				);
				filters[key].push(
					'Let It Snowman + Green Fir Ever + Blue Snowflakes'
				);
			}
			if (filters[key].includes('Pizza Day')) {
				filters[key].push('Pizza Party + Grey Cabana Stripe');
				filters[key].push("Pizza Day + Let's Taco About It");
				filters[key].push('Pizza Day + Grey Cabana Stripe');
				filters[key].push("Let's Taco About It + Pizza Day");
			}
			if (filters[key].includes('Top Dog On Grey')) {
				filters[key].push('Top Dog on Grey');
				filters[key].push('Top Dog On Grey + Grey Cabana Stripe');
			}
			if (filters[key].includes('Rainbow Sprinkles')) {
				filters[key].push('Rainbow Sprinkles + Pink Cabana Stripe');
			}
			if (filters[key].includes('Navy Shibori')) {
				filters[key].push('Barking Lot + Navy Shibori');
				filters[key].push('Navy Shibori + Blue Cabana Stripe');
			}
			if (filters[key].includes('Black Gingham')) {
				filters[key].push('Black + White Gingham');
			}
			if (filters[key].includes('Pink Camel')) {
				filters[key].push('Pink Camel + Pink Cabana Stripe');
			}
			if (filters[key].includes('Spaceship')) {
				filters[key].push('Spaceship + Blue Cabana Stripe');
			}
			if (filters[key].includes('Rainbow Dinosaurs')) {
				filters[key].push('Rainbow Dinosaur');
				filters[key].push('Black Dinosaur');
				filters[key].push('Dinosaur');
			}
			if (filters[key].includes('Light the Menorah')) {
				filters[key].push('Dreidel Dreidel Dreidel');
			}
			if (filters[key].includes('Jet Set Light Blue')) {
				filters[key].push('Jet Set on White');
				filters[key].push('Jet Set on Heather Grey');
				filters[key].push('Jet Set');
			}
			if (filters[key].includes('Sheep Squad')) {
				filters[key].push('Sheep Squad + Grey Cabana Stripe');
			}
			if (filters[key].includes('Marshmallow Treats')) {
				filters[key].push('Marshmallow Treats On Blue');
				filters[key].push('Marshmallow Treats on Blue');
			}
			if (filters[key].includes('Double Trouble Puppies')) {
				filters[key].push('Double Trouble Puppies + Heather Grey');
				filters[key].push(
					'Double Trouble Puppies + Grey Cabana Stripe'
				);
			}
			if (filters[key].includes('Apple Orchard')) {
				filters[key].push('Fall Leaves');
			}
			if (filters[key].includes('Orange')) {
				filters[key].push('Fall Multipack');
				filters[key].push('Peach');
			}
			if (filters[key].includes('White')) {
				filters[key].push('White + Grey');
				filters[key].push('White + Navy');
				filters[key].push('White + Pink');
				filters[key].push('White with Grey Font');
				filters[key].push('White with Cream Font');
				filters[key].push('White Eyelet');
			}
			if (filters[key].includes('Pizza Lovers')) {
				filters[key].push('Pizza Party');
				filters[key].push('Pizza Slice');
				filters[key].push('Deep Dish Pizza');
				filters[key].push('Pizza Day Costume');
				filters[key].push('Tavern Style Pizza');
			}
			if (filters[key].includes('Ski Squad')) {
				filters[key].push('Snowboarder');
				filters[key].push('Skiier');
			}
			if (filters[key].includes('D100 Mickey Mouse on Heather Grey')) {
				filters[key].push('D100 Mickey Mouse on White');
				filters[key].push('D100 Mickey + Friends on Mint');
				filters[key].push('D100 Mickey + Friends on Heather Grey');
				filters[key].push('Mickey Mouse');
			}
			if (filters[key].includes('D100 Minnie Mouse on Light Pink')) {
				filters[key].push('D100 Minnie Mouse on White');
				filters[key].push('Minnie Mouse');
			}
			if (filters[key].includes('Rainbow Ombre Elephant')) {
				filters[key].push('Rainbow Jet Set');
			}
			if (filters[key].includes('Disney Princess')) {
				filters[key].push('Disney Princess Ariel');
				filters[key].push('Disney Princess Belle');
				filters[key].push('Disney Princess Mulan');
				filters[key].push('Disney Princess Tiana');
				filters[key].push('Disney Princess Jasmine');
				filters[key].push('Disney Princess on Mint');
				filters[key].push('Disney Princess on White');
				filters[key].push('Disney Princess Cinderella');
				filters[key].push('D100 Disney Princess on White');
				filters[key].push('Disney Princess on Heather Grey');
				filters[key].push('D100 Disney Princess on Light Pink');
			}
			if (filters[key].includes("Disney's Frozen")) {
				filters[key].push("Disney's Frozen Anna");
				filters[key].push("Disney's Frozen Elsa");
				filters[key].push("Disney's Frozen Olaf");
			}
			if (filters[key].includes('Mint + White Classic Stripe')) {
				filters[key].push('Mint + White French Stripe');
				filters[key].push('Mint Gingham');
			}
			if (filters[key].includes('Lighthouse')) {
				filters[key].push('Lighthouse + Navy');
			}
			if (filters[key].includes('Set Sail')) {
				filters[key].push('Set Sail + Navy');
			}

			return filters[key].includes(variant[key]);
		});
	});

	return filteredVariants;
};

export function groupByKey(array, key) {
	return array.reduce((hash, obj) => {
		if (obj[key] === undefined) return hash;
		return Object.assign(hash, {
			[obj[key]]: (hash[obj[key]] || []).concat(obj),
		});
	}, {});
}

export const getUniqueListBy = (arr, key) => {
	return [...new Map(arr.map((item) => [item[key], item])).values()];
};

export const mergedArraysByKey = (array, key) => {
	let map = {};
	array.forEach((val) => {
		if (map[val[key]]) {
			map[val[key]] = { ...map[val[key]], ...val };
		} else {
			map[val[key]] = val;
		}
	});
	return Object.keys(map).map((val) => map[val]);
};

export const partition = (array, filter) => {
	let pass = [],
		fail = [];
	array.forEach((e, idx, arr) => (filter(e, idx, arr) ? pass : fail).push(e));
	return [pass, fail];
};

export function isEmpty(obj) {
	if (obj) {
		return Object.getOwnPropertyNames(obj).length === 0;
	} else {
		return true;
	}
}

export const deepEqual = (x, y) => {
	const ok = Object.keys,
		tx = typeof x,
		ty = typeof y;
	return x && y && tx === 'object' && tx === ty
		? ok(x).length === ok(y).length &&
				ok(x).every((key) => deepEqual(x[key], y[key]))
		: x === y;
};

export const shuffle = (a) => {
	var j, x, i;
	for (i = a.length - 1; i > 0; i--) {
		j = Math.floor(Math.random() * (i + 1));
		x = a[i];
		a[i] = a[j];
		a[j] = x;
	}
	return a;
};

export const endsWithNumber = (str) => {
	return isNaN(str.slice(-1)) ? false : true;
};

export const getSessionStorageOrDefault = (key, defaultValue) => {
	const stored = sessionStorage.getItem(key);
	if (!stored) {
		return defaultValue;
	}
	return JSON.parse(stored);
};

export function slugify(string) {
	// Add null check to prevent toString() errors
	if (!string) {
		return ''
	}

	const a =
		'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
	const b =
		'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
	const p = new RegExp(a.split('').join('|'), 'g');

	return string
		.toString()
		.toLowerCase()
		.replace(/\s+/g, '-') // Replace spaces with -
		.replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
		.replace(/&/g, '-and-') // Replace & with 'and'
		.replace(/[^\w\-]+/g, '') // Remove all non-word characters
		.replace(/\-\-+/g, '-') // Replace multiple - with single -
		.replace(/^-+/, '') // Trim - from start of text
		.replace(/-+$/, ''); // Trim - from end of text
}

/**
 * Generates strategic slug variations to handle common cases where extra characters are inserted
 * This is much more efficient than the previous approach that removed every character
 *
 * @param {string} slug - The original slug to generate variations for
 * @returns {string[]} Array of strategic variations
 */
export function generateSlugVariations(slug) {
	// console.log(`🔄 generateSlugVariations called with: ${slug}`)

	if (!slug || typeof slug !== 'string') {
		return []
	}

	const variations = []

	// Dynamic pattern to remove any single character surrounded by hyphens
	// This handles cases like: "wave-w-dress", "short-s-sleeve", "product-a-name", etc.
	// But preserve common product terms like "2-pack", "3-pack", etc.
	const singleCharPattern = /-([a-zA-Z0-9])-/g

	// Apply the dynamic single character removal pattern FIRST (highest priority)
	if (singleCharPattern.test(slug)) {
		// Create a more sophisticated replacement that preserves pack terms
		let variation = slug

		// First, temporarily replace pack terms to protect them
		variation = variation.replace(/(\d)-pack/g, 'PACK_PRESERVE_$1-pack')

		// Apply single character removal (but not to preserved pack terms)
		variation = variation.replace(singleCharPattern, '-')

		// Restore preserved pack terms
		variation = variation.replace(/PACK_PRESERVE_(\d)-pack/g, '$1-pack')

		if (variation !== slug) {
			variations.push(variation)
			// console.log(`📝 Generated variation (single char removal): ${variation}`)
		}
	}

	// Handle dash variations (single vs double dashes)
	const singleDashVersion = slug.replace(/--/g, '-')
	const doubleDashVersion = slug.replace(/-/g, '--')

	if (singleDashVersion !== slug) {
		variations.push(singleDashVersion)
		// console.log(`📝 Generated variation (single dash): ${singleDashVersion}`)
	}
	if (doubleDashVersion !== slug) {
		variations.push(doubleDashVersion)
		// console.log(`📝 Generated variation (double dash): ${doubleDashVersion}`)
	}

	// Handle common prefixes/suffixes that might be added
	const commonPrefixes = ['sale-', 'new-', 'featured-', 'best-']
	const commonSuffixes = ['-sale', '-new', '-featured', '-bundle', '-set']

	commonPrefixes.forEach(prefix => {
		if (slug.startsWith(prefix)) {
			const variation = slug.substring(prefix.length)
			variations.push(variation)
			// console.log(`📝 Generated variation (prefix removal): ${variation}`)
		}
	})

	commonSuffixes.forEach(suffix => {
		if (slug.endsWith(suffix)) {
			const variation = slug.substring(0, slug.length - suffix.length)
			variations.push(variation)
			// console.log(`📝 Generated variation (suffix removal): ${variation}`)
		}
	})

	// Handle cases where additional words/phrases are appended
	// This is the key enhancement for cases like "sunshine-tank-top-pocket-t-short-set"
	const words = slug.split('-')

	// Try removing words from the end to find the base handle
	// Start with removing 1 word, then 2, then 3, etc.
	for (let i = 1; i <= Math.min(4, words.length - 2); i++) {
		const baseWords = words.slice(0, words.length - i)
		const baseHandle = baseWords.join('-')
		if (baseHandle.length >= 3) { // Ensure we have a reasonable base handle
			variations.push(baseHandle)
			// console.log(`📝 Generated variation (end removal ${i}): ${baseHandle}`)
		}
	}

	// Also try removing words from the beginning
	for (let i = 1; i <= Math.min(2, words.length - 2); i++) {
		const baseWords = words.slice(i)
		const baseHandle = baseWords.join('-')
		if (baseHandle.length >= 3) { // Ensure we have a reasonable base handle
			variations.push(baseHandle)
			// console.log(`📝 Generated variation (start removal ${i}): ${baseHandle}`)
		}
	}

	// Add space-based variations for better product matching
	// Convert hyphens to spaces for cases like "wave-dress-shorts-bundle" -> "wave dress shorts bundle"
	const spaceBasedVariation = slug.replace(/-/g, ' ')
	if (spaceBasedVariation !== slug) {
		variations.push(spaceBasedVariation)
		// console.log(`📝 Generated variation (space-based): ${spaceBasedVariation}`)
	}

	// Also add space-based variations for the dynamic single character removal
	if (singleCharPattern.test(slug)) {
		// Create a more sophisticated replacement that preserves pack terms
		let variation = slug

		// First, temporarily replace pack terms to protect them
		variation = variation.replace(/(\d)-pack/g, 'PACK_PRESERVE_$1-pack')

		// Apply single character removal (but not to preserved pack terms)
		variation = variation.replace(singleCharPattern, '-')

		// Restore preserved pack terms
		variation = variation.replace(/PACK_PRESERVE_(\d)-pack/g, '$1-pack')

		if (variation !== slug) {
			const spaceVariation = variation.replace(/-/g, ' ')
			if (spaceVariation !== variation) {
				variations.push(spaceVariation)
				// console.log(`📝 Generated variation (space + char removal): ${spaceVariation}`)
			}
		}
	}

	// Remove duplicates and return
	const uniqueVariations = [...new Set(variations)]
	// console.log(`📝 Final unique variations for "${slug}":`, uniqueVariations)
	return uniqueVariations
}

export function unslugify(slug) {
	const result = slug.replace(/\-/g, ' ');
	return result.replace(/\w\S*/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
}

export function groupBy(arr, property) {
	return arr.reduce(function (memo, x) {
		if (!memo[x[property]]) {
			memo[x[property]] = [];
		}
		memo[x[property]].push(x);
		return memo;
	}, {});
}

export function mapOrder(array, myorder, key) {
	var order = myorder.reduce((r, k, i) => ((r[k] = i + 1), r), {});
	const sortedArray = array.sort(
		(a, b) => (order[a[key]] || Infinity) - (order[b[key]] || Infinity)
	);
	return sortedArray;
}

/**
 * @description
 * Takes an Array<V>, and a grouping function,
 * and returns a Map of the array grouped by the grouping function.
 *
 * @param list An array of type V.
 * @param keyGetter A Function that takes the the Array type V as an input, and returns a value of type K.
 *                  K is generally intended to be a property key of V.
 *
 * @returns Map of the array grouped by the grouping function.
 */
//export function groupBy<K, V>(list: Array<V>, keyGetter: (input: V) => K): Map<K, Array<V>> {
//    const map = new Map<K, Array<V>>();
export function groupedMap(list, keyGetter) {
	const map = new Map();
	list.forEach((item) => {
		const key = keyGetter(item);
		const collection = map.get(key);
		if (!collection) {
			map.set(key, [item]);
		} else {
			collection.push(item);
		}
	});
	return map;
}

export function arrayReverse(array) {
	var first = null;
	var last = null;
	var tmp = null;
	var length = array.length;

	for (first = 0, last = length - 1; first < length / 2; first++, last--) {
		tmp = array[first];
		array[first] = array[last];
		array[last] = tmp;
	}
}

export function swapper(obj) {
	let result = Object.fromEntries(
		Object.values(obj).map((value) => [value, []])
	);
	for (let [key, value] of Object.entries(obj)) result[value].push(key);
	for (let [key, value] of Object.entries(result)) {
		if (value.length === 1) result[key] = value[0];
	}
	return result;
}

export function sizeSortFunc(a, b) {
	let sortingArr = SIZES;
	return (
		sortingArr.indexOf(a.initial_size) - sortingArr.indexOf(b.initial_size)
	);
}

export const getShuffledArray = (arr) => {
	const newArr = arr.slice();
	for (let i = newArr.length - 1; i > 0; i--) {
		const rand = Math.floor(Math.random() * (i + 1));
		[newArr[i], newArr[rand]] = [newArr[rand], newArr[i]];
	}
	return newArr;
};

export const insertParam = (key, value) => {
	// key = encodeURIComponent(key)
	value = decodeURIComponent(value);

	let kvp = window.location.search.substr(1).split('&');

	if (kvp[0] === '') {
		let path =
			window.location.protocol +
			'//' +
			window.location.host +
			window.location.pathname +
			'?' +
			key +
			'=' +
			value;
		path = path.replace(/\+/g, '%20');
		path = path.replace('=undefined', '');
		path = decodeURIComponent(path);

		window.history.pushState({ path: path }, '', path);
	} else {
		let i = kvp.length;
		let x;
		while (i--) {
			x = kvp[i].split('=');

			if (x[0] === key) {
				x[1] = value;
				kvp[i] = x.join('=');
				// break
			}
		}

		if (i < 0) {
			kvp[kvp.length] = [key, value].join('=');
		}

		let refresh =
			window.location.protocol +
			'//' +
			window.location.host +
			window.location.pathname +
			'?' +
			convertToQueryCompatible(kvp.join('&'));

		refresh = refresh.replace(/\+/g, '%20');
		refresh = refresh.replace(/%2520/g, '%20');
		refresh = refresh.replace('=undefined', '');
		window.history.pushState({ path: refresh }, '', refresh);
	}
};

export function insertUrlParam(key, value) {
	if (history.pushState) {
		let searchParams = new URLSearchParams(window.location.search);
		searchParams.set(key, value);
		let newurl =
			window.location.protocol +
			'//' +
			window.location.host +
			window.location.pathname +
			'?' +
			searchParams.toString();
		window.history.pushState({ path: newurl }, '', newurl);
	}
}

export function replaceUrlParam(key, value) {
	if (history.pushState) {
		let searchParams = new URLSearchParams(window.location.search);
		searchParams.set(key, value);
		let newurl =
			window.location.protocol +
			'//' +
			window.location.host +
			window.location.pathname +
			'?' +
			searchParams.toString();
		window.history.replaceState({ path: newurl }, '', newurl);
	}
}

export function addUrlParameter(
	sourceUrl,
	parameterName,
	parameterValue,
	replaceDuplicates
) {
	if (sourceUrl == null || sourceUrl.length == 0)
		sourceUrl = document.location.href;
	var urlParts = sourceUrl.split('?');
	var newQueryString = '';
	if (urlParts.length > 1) {
		var parameters = urlParts[1].split('&');
		for (var i = 0; i < parameters.length; i++) {
			var parameterParts = parameters[i].split('=');
			if (!(replaceDuplicates && parameterParts[0] == parameterName)) {
				if (newQueryString == '') newQueryString = '?';
				else newQueryString += '&';
				newQueryString += parameterParts[0] + '=' + parameterParts[1];
			}
		}
	}
	if (newQueryString == '') newQueryString = '?';
	else newQueryString += '&';
	newQueryString += parameterName + '=' + parameterValue;

	return urlParts[0] + newQueryString;
}

/**
 * Adds multiple parameters to the current URL, maintaining existing parameters, and updates the URL in place without a reload.
 * @param {Object} params - An object containing the parameters to add.
 */
export function addParamsToUrl(params) {
	if (history.pushState) {
		// Parse the existing URL
		let urlObj = new URL(window.location.href);

		// Create a URLSearchParams object from the existing query parameters
		let searchParams = new URLSearchParams(urlObj.search);

		// Add the new parameters to the URLSearchParams object
		for (let key in params) {
			if (params.hasOwnProperty(key)) {
				searchParams.set(key, params[key]);
			}
		}

		// Update the URL with the new query parameters
		let newUrl = `${urlObj.origin}${
			urlObj.pathname
		}?${searchParams.toString()}`;
		window.history.pushState({ path: newUrl }, '', newUrl);
	}
}

export function addQueryParams(params) {
	// Parse the current URL
	const url = new URL(window.location.href);

	// Parse the incoming parameters
	const newParams = new URLSearchParams(params);

	// Append or update the parameters
	// We need append here because we want to add multiple values for the same key
	newParams.forEach((value, key) => {
		url.searchParams.append(key, value);
	});

	const urlDecoded = decodeURIComponent(
		url.toString().replace(/\+/g, '%20')
	).replace(/\+/g, '%2B');

	// Update the URL without reloading the page
	window.history.replaceState({}, '', urlDecoded);

	return urlDecoded;
}

// export function insertUrlParam(key, value) {
//     let $currentUrl = currentUrl.get()
//     if ($currentUrl) {
//         let baseUrl = $currentUrl.split('?')[0]
//         let searchParams = $currentUrl.split('?')[1]
//         searchParams = searchParams + '&' + key + '=' + value
//         let newurl =
//             baseUrl + '?' + searchParams.toString()
//
//         currentUrl.set(newurl)
//         window.history.pushState({ path: newurl }, '', newurl)
//         return newurl
//     }
// }

export const removeQueryString = (key, value, url) => {
	// TODO: update this to remove ? if no other query string
	if (!url) url = window.location.href;

	let decodedValue = decodeURIComponent(value);

	let updated = url.replace(
		new RegExp(`([?&])${key}=${value}(&|$)`, 'g'),
		function (match, p1, p2) {
			if (p2 === '&') return p1; // Preserve preceding '&'
			return ''; // Remove the match
		}
	);

	//   // Remove leading '?' or '&' if it's at the end of the URL
	//   updated = updated.replace(/[?&]$/, '');

	// Remove leading '?' or '&' if it's at the end of the URL
	updated = updated.replace(/[?&]$/, '');

	window.history.replaceState({ path: updated }, '', updated);
};

export const formatQueryStringValues = (data) => {
	let values;
	if (Array.isArray(data)) {
		values = data;
	} else {
		values = data.split();
	}
	return values;
};

export function removeSelectedFilters(jsonArray) {
	// List of filter types to identify
	const targetFilterTypes = [
		'opt_size',
		'opt_pattern',
		'product_type',
		'opt_gender',
	];

	// Loop through each JSON entry in the array
	jsonArray.forEach((entry) => {
		// Check if the entry has one of the target filter types
		if (targetFilterTypes.includes(entry.filterType)) {
			// Loop through the "values" array within the entry
			entry.values.forEach((value) => {
				// Set 'selected' to false if it is currently true
				if (value.selected === true) {
					value.selected = false;
				}
			});
		}
	});

	return jsonArray; // Return the modified array
}

export const removeParam = (paramName) => {
	let searchParams = new URLSearchParams(window.location.search);
	searchParams.delete(paramName);

	if (history.replaceState) {
		let searchString =
			searchParams.toString().length > 0
				? '?' + searchParams.toString().replace(/\+/g, '%20')
				: '';
		let newUrl =
			window.location.protocol +
			'//' +
			window.location.host +
			window.location.pathname +
			searchString +
			window.location.hash;
		history.replaceState(null, '', newUrl);
	}
};

export const removeParamValue = (paramName, paramValuesToRemove) => {
	// Ensure paramValuesToRemove is an array
	if (!Array.isArray(paramValuesToRemove)) {
		paramValuesToRemove = [paramValuesToRemove];
	}

	let searchParams = new URLSearchParams(window.location.search);

	// Get all values for the parameter
	let values = searchParams.getAll(paramName);

	// Special handling for gender parameter
	if (paramName === 'pf_opt_gender') {
		// If removing Boy or Girl and Unisex exists, add Unisex to removal list
		if (
			(paramValuesToRemove.includes('Boy') ||
				paramValuesToRemove.includes('Girl')) &&
			values.includes('Unisex')
		) {
			paramValuesToRemove.push('Unisex');
		}
	}

	// Remove all instances of this parameter
	searchParams.delete(paramName);

	// Add back all values except those in paramValuesToRemove
	values.forEach((value) => {
		if (!paramValuesToRemove.includes(value)) {
			searchParams.append(paramName, value);
		}
	});

	if (history.replaceState) {
		let searchString =
			searchParams.toString().length > 0
				? '?' + searchParams.toString().replace(/\+/g, '%20')
				: '';
		let newUrl =
			window.location.protocol +
			'//' +
			window.location.host +
			window.location.pathname +
			searchString +
			window.location.hash;
		history.replaceState(null, '', newUrl);
	}
};

export const convertToQueryCompatible = (string) => {
	string = string.replace(/ /g, '%20');
	string = string.replace(/\//g, '%2F');
	string = string.replace(/\+/g, '%2B');
	string = string.replace(/™/g, '%E2%84%A2');

	return string;
};

export const convertParsedObjectToArray = (parsed) => {
	if (parsed['pf_opt_size']) {
		if (!Array.isArray(parsed['pf_opt_size'])) {
			parsed['pf_opt_size'] = parsed['pf_opt_size'].split();
		}
	}

	if (parsed['pf_opt_pattern']) {
		if (!Array.isArray(parsed['pf_opt_pattern'])) {
			parsed['pf_opt_pattern'] = parsed['pf_opt_pattern'].split();
		}
	}

	if (parsed['pf_pt_product_type']) {
		if (!Array.isArray(parsed['pf_pt_product_type'])) {
			parsed['pf_pt_product_type'] = parsed['pf_pt_product_type'].split();
		}
	}

	if (parsed['pf_opt_gender']) {
		if (!Array.isArray(parsed['pf_opt_gender'])) {
			parsed['pf_opt_gender'] = parsed['pf_opt_gender'].split();
		}
	}

	if (parsed['tag']) {
		if (!Array.isArray(parsed['tag'])) {
			parsed['tag'] = parsed['tag'].split();
		}
	}

	return parsed;
};

// export function fileNameAndExt(str) {
//     var file = str.split('/').pop()
//     return [
//         file.substr(0, file.lastIndexOf('.')),
//         file.substr(file.lastIndexOf('.') + 1, file.length),
//     ]
// }

export function fileNameAndExt(str) {
	if (str === null || str === undefined) return null;
	var file = str.substr(0, str.lastIndexOf('/'));
	var fileExt = str.split('/').pop();
	return [
		file,
		fileExt.substr(0, fileExt.lastIndexOf('.')),
		fileExt.substr(fileExt.lastIndexOf('.') + 1, fileExt.length),
	];
}

export function sleep(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms || DEF_DELAY));
}

export const simulateClick = (elem) => {
	// Create our event (with options)
	var evt = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window,
	});
	// If cancelled, don't dispatch our event
	var canceled = !elem.dispatchEvent(evt);
};

export function addHours(date, hours) {
	date.setTime(date.getTime() + hours * 60 * 60 * 1000);
	return date;
}

export function convertToCurrency(str) {
	var n = Number.parseFloat(str);
	if (!str || isNaN(n) || n < 0) return null;
	return n.toFixed(2);
}

export function roundUpIfDotNine(n) {
	var radix = n % 1.0;
	if (radix > 0.899 && radix < 1.0) {
		return Math.ceil(n).toFixed(2);
	} else {
		return n;
	}
}

export const getCookie = (cname) => {
	var name = cname + '=';
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
};

export const setCookie = (cname, cvalue, exdays) => {
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	let expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

export const buildAllCollections = (col1, col2) => {
	let allCollections;
	if (col1 && col2) {
		allCollections = col1.concat(col2);
	} else if (!col2) {
		allCollections = col1;
	} else if (!col1) {
		allCollections = col2;
	}

	return allCollections;
};

export const insertIntoArray = (arr, index, newItem) => [
	// part of the array before the specified index
	...arr.slice(0, index),
	// inserted item
	newItem,
	// part of the array after the specified index
	...arr.slice(index),
];

/* used for inserting content cards into PLP array */
export const insertMultipleIntoArray = (array, indices, items) => {
	let newArray = [...array];
	let offset = 0;
	indices.forEach((index, i) => {
		newArray.splice(index + offset, 0, items[i]);
		offset++;
	});
	return newArray;
};

export const dynamicSort = (property) => {
	var sortOrder = 1;
	if (property[0] === '-') {
		sortOrder = -1;
		property = property.substr(1);
	}
	return function (a, b) {
		/* next line works with strings and numbers,
		 * and you may want to customize it to your needs
		 */
		var result =
			a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
		return result * sortOrder;
	};
};

export const sortByKey = (array, key) => {
	return array.sort(function (a, b) {
		return a[key] - b[key];
	});
};

export const truncateString = (str, maxLen, separator = ' ') => {
	if (str?.length <= maxLen) return str;
	return str?.substr(0, str?.lastIndexOf(separator, maxLen));
};

export function splitLastOccurrence(str, substring) {
	if (
		str === null ||
		str === undefined ||
		substring === null ||
		substring === undefined
	)
		return null;
	const lastIndex = str.lastIndexOf(substring);

	const before = str.slice(0, lastIndex);

	const after = str.slice(lastIndex + 1);

	return [before, after];
}

export function round(num, decimalPlaces = 0) {
	var p = Math.pow(10, decimalPlaces);
	var n = num * p * (1 + Number.EPSILON);
	return Math.round(n) / p;
}

// export function round(num, decimalPlaces = 0) {
//     if (num < 0) return -round(-num, decimalPlaces)
//     var p = Math.pow(10, decimalPlaces)
//     var n = num * p
//     var f = n - Math.floor(n)
//     var e = Number.EPSILON * n

//     // Determine whether this fraction is a midpoint value.
//     return f >= 0.5 - e ? Math.ceil(n) / p : Math.floor(n) / p
// }

export function isEven(value) {
	if (value % 2 == 0) return true;
	else return false;
}

export function uuidv4() {
	return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
		(
			c ^
			(crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
		).toString(16)
	);
}

export const fadeIn = (element, duration) => {
	(function increment(value = 0) {
		element.style.opacity = String(value);
		if (element.style.opacity !== '1') {
			setTimeout(() => {
				increment(value + 0.1);
			}, duration / 10);
		}
	})();
};

export const fadeOut = (element, duration) => {
	(function decrement() {
		(element.style.opacity -= 0.1) < 0
			? null
			: setTimeout(() => {
					decrement();
			  }, duration / 10);
	})();
};

export const getHexClass = (hex) => {
	return `text-[${hex}]`;
};

export function getEmbroideryImages() {
	const images = [
		{
			webName: 'Default',
			slug: 'embroidery-default',
			fontName: 'embroidery-default',
			image: require('../../src/assets/images/embroidery-default.png'),
		},
		{
			webName: 'Mama',
			slug: 'mama',
			fontName: 'mama-font',
			image: require('../../src/assets/images/mama.png'),
		},
		{
			webName: 'Block Print',
			slug: 'block-print',
			fontName: 'Block',
			image: require('../../src/assets/images/block-print.png'),
		},
		{
			webName: 'Classic Cursive',
			slug: 'classic-cursive',
			fontName: 'Script Bold',
			image: require('../../src/assets/images/classic-cursive.png'),
		},
		{
			webName: 'Diamond Monogram',
			slug: 'diamond-monogram',
			fontName: 'Diamond Monogram',
			image: require('../../src/assets/images/diamond-monogram.png'),
		},
		{
			webName: 'Handwriting',
			slug: 'handwriting',
			fontName: 'Liverpool',
			image: require('../../src/assets/images/handwriting.png'),
		},
		{
			webName: 'Modern Cursive',
			slug: 'modern-cursive',
			fontName: 'Sweatpants',
			image: require('../../src/assets/images/modern-cursive.png'),
		},
		{
			webName: 'Script Bold Monogram',
			slug: 'script-bold-monogram',
			fontName: 'Script Bold Monogram',
			image: require('../../src/assets/images/script-bold-monogram.png'),
		},
		{
			webName: 'Script Bold Single',
			slug: 'script-bold-single',
			fontName: 'Script Bold Single',
			image: require('../../src/assets/images/script-bold-single.png'),
		},
		{
			webName: 'Serif',
			slug: 'serif',
			fontName: 'Brussels Light',
			image: require('../../src/assets/images/serif.png'),
		},
		{
			webName: 'Typewriter',
			slug: 'typewriter',
			fontName: 'Panama Bold',
			image: require('../../src/assets/images/typewriter.png'),
		},
		{
			webName: 'Varsity Letter',
			slug: 'varsity-letter',
			fontName: 'Varsity Letter',
			image: require('../../src/assets/images/varsity-letter.png'),
		},
	];

	return images;
}

export const SIZES = [
	'Premie',
	'preemie',
	'newborn',
	'0-2Y',
	'0–2Y',
	'0-3m',
	'0–3m',
	'3-6m',
	'3–6m',
	'0-6m',
	'0–6m',
	'6-9m',
	'6–9m',
	'0-12m',
	'0–12m',
	'9-12m',
	'9–12m',
	'6-12m',
	'6–12m',
	'12-18m',
	'12–18m',
	'12-24m',
	'12–24m',
	'18-24m',
	'18–24m',
	'1T',
	'2T',
	'2T-6',
	'2T–6',
	'2/3T',
	'2–3T',
	'2-3T',
	'3T',
	'3–6Y',
	'3-6Y',
	'4T',
	'4–5T',
	'4-5T',
	'4/5T',
	'4/6Y',
	'5T',
	'6T',
	'6T-8',
	'6T-8',
	'6+',
	'6/7',
	'6/8',
	'6–8Y',
	'6-8Y',
	'7/8Y',
	'7-12Y',
	'7–12Y',
	'8',
	'9/10Y',
	'10',
	'12',
	'12Y',
	'12-5T',
	'12–5T',
	'14',
	'14Y',
	'XS',
	'XS/S',
	'S',
	'small',
	'Small',
	'M',
	'medium',
	'Medium',
	'M/L',
	'L',
	'large',
	'Large',
	'L/XL',
	'XL',
	'XL/XXL',
	'XXL',
	'XXXL',
	'2XL',
	'3XL',
	'4XL',
	'xl',
	'xxl',
	'xxxl',
	'2xl',
	'3xl',
	'4xl',
	'adult',
	'Big Kid',
	'Little Kid',
	'Adult',
];

export const babySizes = [
	'Premie',
	'preemie',
	'newborn',
	'0-2Y',
	'0–2Y',
	'0-3m',
	'0–3m',
	'3-6m',
	'3–6m',
	'0-6m',
	'0–6m',
	'6-9m',
	'6–9m',
	'0-12m',
	'0–12m',
	'9-12m',
	'9–12m',
	'6-12m',
	'6–12m',
	'12-18m',
	'12–18m',
	'12-24m',
	'12–24m',
	'18-24m',
	'18–24m',
];
export const toddlerSizes = [
	'1T',
	'2T',
	'2/3T',
	'2–3T',
	'2-3T',
	'3T',
	'3–6Y',
	'3-6Y',
	'4T',
	'4–5T',
	'4-5T',
	'4/5T',
	'4/6Y',
	'5T',
];
export const kidsSizes = [
	'6T',
	'6T-8',
	'6T-8',
	'6/7',
	'6/8',
	'6–8Y',
	'6-8Y',
	'7/8Y',
	'7-12Y',
	'7–12Y',
	'8',
	'9/10Y',
	'10',
	'12',
	'12-5T',
	'12–5T',
	'14',
];

const NAME_RE = /^(?!=).*$/g;

export const isInputTextValid = (ev) => {
	// Validate value don't start with '='
	if (!ev.target.value.match(NAME_RE)) {
		ev.preventDefault();
		return false;
	}
	return true;
};

export const EMAIL_RE = /^[\w-+\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

export const IsEmail = (email) => {
	var regex =
		/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	if (!regex.test(email)) {
		return false;
	} else {
		return true;
	}
};

export const removeOutOfStockProductsWithSameHandle = (products, handle) => {
	const filteredProducts = products.filter((p) => {
		if (p.handle.split('_')[0] === handle) {
			if (!p.title.includes('[hidden]')) {
				let zeroInventoryVariant = 0;
				p.variants.forEach((v) => {
					if (v.inventory_quantity === 0) {
						zeroInventoryVariant = zeroInventoryVariant + 1;
					}
				});
				// if all variants are zeroInventoryVariants then remove the product
				if (p.variants.length === zeroInventoryVariant) {
					return false;
				}
				return p.available;
			}
		}
		return false;
	});
	return filteredProducts;
};

export const mapVariantsToMetafields = (product, variants) => {
	const variantsWithMetafields = variants?.map((v) => {
		if (v?.product_id?.toString() === product?.id?.toString()) {
			product?.metafields?.forEach((m) => {
				if (m?.id?.toString() === v?.id?.toString()) {
					v.metafields = m;
				}
			});
		}
		return v;
	});
	return variantsWithMetafields;
};

export const removeOutOfStockProducts = (products) => {
	const filteredProducts = products.filter((p) => {
		if (!p.title.includes('[hidden]')) {
			let zeroInventoryVariant = 0;
			p.variants.forEach((v) => {
				if (v.inventory_quantity === 0) {
					zeroInventoryVariant = zeroInventoryVariant + 1;
				}
			});
			// if all variants are zeroInventoryVariants then remove the product
			return p.variants.length != zeroInventoryVariant;
		}
		return true;
	});

	return filteredProducts;
};

// export const findEffVariantsWithInventory = async (variants) => {
// 	const stockCache = new Map();

// 	const variantOgProductInventoryPromises = variants.map(async (variant) => {
// 		if (variant.metafields.key == "source_variant") {
// 			const inventoryResults = await Promise.all(
// 				JSON.parse(variant.metafields.value).map(async (ogProduct) => {
// 					if (stockCache.has(ogProduct.product_id.toString())) {
// 						const vStockCache = stockCache.get(ogProduct.product_id.toString());
// 						if (vStockCache.has(ogProduct.variant_id.toString())) {
// 							return vStockCache.get(ogProduct.variant_id.toString());
// 						}
// 					}

// 					const variantStockCache = new Map();
// 					let returnValue;
// 					const data = await getProductInventory(ogProduct.product_id);
// 					if (data?.inventory == 0) {
// 						returnValue = [0];
// 					} else {
// 						returnValue = data.product.variants.nodes.map((ogVariant) => {
// 							if (ogProduct.variant_id.toString() === ogVariant.id.toString()) {
// 								variantStockCache.set(
// 									ogVariant.id,
// 									ogVariant.quantityAvailable
// 								);
// 								return ogVariant.quantityAvailable;
// 							}
// 							variantStockCache.set(
// 								ogVariant.id.toString(),
// 								ogVariant.quantityAvailable
// 							);
// 						});
// 					}

// 					stockCache.set(ogProduct.product_id.toString(), variantStockCache);
// 					return returnValue.filter((item) => typeof item === "number")[0];
// 				})
// 			);
// 			variant.inventory_quantity = Math.min(...inventoryResults);
// 		}
// 		return variant;
// 	});

// 	return Promise.all(variantOgProductInventoryPromises);
// };

// Modified findEffVariantsWithInventory with chunking and rate limiting

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const findEffVariantsWithInventory = async (variants) => {
	const stockCache = new Map();
	const CHUNK_SIZE = 5; // Process 5 variants at a time
	const RATE_LIMIT_DELAY = 500; // 500ms between chunks

	// Helper function to process variants in chunks
	const processVariantsInChunks = async (variants) => {
		const results = [];
		for (let i = 0; i < variants.length; i += CHUNK_SIZE) {
			const chunk = variants.slice(i, i + CHUNK_SIZE);
			const chunkPromises = chunk.map(async (variant) => {
				if (variant.metafields.key == 'source_variant') {
					const sourceVariants = JSON.parse(variant.metafields.value);
					const inventoryResults = await processInventoryChecks(
						sourceVariants,
						stockCache
					);
					variant.inventory_quantity = Math.min(...inventoryResults);
				}
				return variant;
			});

			// Process chunk
			const chunkResults = await Promise.all(chunkPromises);
			results.push(...chunkResults);

			// Rate limiting delay between chunks
			if (i + CHUNK_SIZE < variants.length) {
				await delay(RATE_LIMIT_DELAY);
			}
		}
		return results;
	};

	return processVariantsInChunks(variants);
};

// Helper function to process inventory checks with caching
async function processInventoryChecks(sourceVariants, stockCache) {
	return Promise.all(
		sourceVariants.map(async (ogProduct) => {
			// Check cache first
			if (stockCache.has(ogProduct.product_id.toString())) {
				const vStockCache = stockCache.get(
					ogProduct.product_id.toString()
				);
				if (vStockCache.has(ogProduct.variant_id.toString())) {
					return vStockCache.get(ogProduct.variant_id.toString());
				}
			}

			try {
				const data = await getProductInventory(ogProduct.product_id);
				return processInventoryData(data, ogProduct, stockCache);
			} catch (error) {
				console.error(
					`Error fetching inventory for product ${ogProduct.product_id}:`,
					error
				);
				return 0; // Return 0 inventory on error
			}
		})
	);
}

// Helper function to process inventory data
function processInventoryData(data, ogProduct, stockCache) {
	const variantStockCache = new Map();

	if (data?.inventory === 0) {
		return 0;
	}

	const inventoryAmount =
		data.product.variants.nodes
			.map((ogVariant) => {
				if (
					ogProduct.variant_id.toString() === ogVariant.id.toString()
				) {
					variantStockCache.set(
						ogVariant.id,
						ogVariant.quantityAvailable
					);
					return ogVariant.quantityAvailable;
				}
				variantStockCache.set(
					ogVariant.id.toString(),
					ogVariant.quantityAvailable
				);
				return null;
			})
			.filter((item) => typeof item === 'number')[0] || 0;

	stockCache.set(ogProduct.product_id.toString(), variantStockCache);
	return inventoryAmount;
}

export const parseNostoRecommendation = (recommendation) => {
	if (typeof recommendation !== 'string') return recommendation;

	try {
		// Clean up the JSON content
		let cleanedRecommendation = recommendation
			// Remove extra whitespace and newlines
			.replace(/\s+/g, ' ')
			// Remove trailing commas
			.replace(/,(\s*[}\]])/g, '$1')
			// Remove extra spaces around commas
			.replace(/\s*,\s*/g, ',')
			// Remove extra spaces around colons
			.replace(/\s*:\s*/g, ':')
			// Remove extra spaces around brackets
			.replace(/\s*\[\s*/g, '[')
			.replace(/\s*\]\s*/g, ']')
			.replace(/\s*\{\s*/g, '{')
			.replace(/\s*\}\s*/g, '}')
			// Remove commas from numbers
			.replace(/(\d+),(\d+)/g, '$1$2');

		return JSON.parse(cleanedRecommendation);
	} catch (err) {
		console.error('Error parsing Nosto recommendation:', err);
		console.error('Problematic content:', recommendation);
		return null;
	}
};

export const DEFAULT_IMAGE_SRC =
	'https://cdn.shopify.com/s/files/1/2338/2917/files/default-image.png?v=1628278950';

// Helper function to transform image URL to specific size
export const getResizedImageUrl = (url, size = '600x900') => {
	if (!url) return DEFAULT_IMAGE_SRC;
	try {
		// Remove any existing size parameters
		const baseUrl = url.split('?')[0];
		// Get the file extension
		const extension =
			baseUrl.match(/\.(jpg|jpeg|png|webp)$/i)?.[0] || '.jpg';
		// Remove file extension
		const withoutExtension = baseUrl.replace(/\.(jpg|jpeg|png|webp)$/i, '');
		// Add size parameter and original extension back
		return `${withoutExtension}_${size}${extension}`;
	} catch (error) {
		console.error('Error transforming image URL:', error);
		return url;
	}
};

export const getTagsByIncludes = (tags, substrings) => {
    if (!Array.isArray(substrings)) substrings = [substrings];
    return tags.filter(tag =>
        substrings.some(sub => tag.toLowerCase().includes(sub.toLowerCase()))
    );
}
